import { FBA_privateAddressTypes } from 'common/constants/permissions';

const canAllowPrivateAddressTypes = permissions => !!permissions[FBA_privateAddressTypes];

export default {
    canAllowPrivateAddressTypes
};
